import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import SecurityForm from "../../components/account/SecurityForm.jsx";
import withBasicForm from "../../components/forms/withBasicForm.js";

const SecurityFormBasicForm = withBasicForm(SecurityForm);

class SecurityTab extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    violationErrors: PropTypes.object
  };

  // -- RENDER -- //

  render() {
    return <SecurityFormBasicForm {...this.props} />;
  }
}

export default SecurityTab;
